import { createContext } from "react";

const potentialCustomerContext = createContext();

export default potentialCustomerContext;
